// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"45447c60","147":"5b49735d","656":"45447c60","830":"45ad1228"}[chunkId] + ".chunk.css";
};